<template>
  <div>
    <b-overlay
      :show="loading"
      rounded
      opacity="1"
      spinner-small
      spinner-variant="primary"
    >
      <div class="mt-4 pt-3" style="min-height: 400px;">
        <div>
          <b-form @submit.prevent="saveChanges">
            <b-table-simple caption-top responsive :busy="loading">
              <b-thead>
                <b-tr>
                  <b-th class="py-3 pl-0 pr-2">Тип подвижного состава</b-th>
                  <b-th class="py-3 px-2 text-center">Общее количество</b-th>
                  <b-th class="py-3 px-2">Вид</b-th>
                  <b-th class="py-3 pl-0 pr-2 text-center">Кол-во по каждому виду</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <template v-for="category in categories" v-if="!category.hide">
                  <b-tr>
                    <b-th 
                      :rowspan="category.items.length + 1" 
                      class="py-3 pl-0 pr-2"
                      style="vertical-align: top; padding-top: 17px !important;"
                    >{{ category.category.name }}</b-th>
                    <b-th 
                      :rowspan="category.items.length + 1" 
                      class="py-3 px-2 text-center"
                      style="vertical-align: top; padding-top: 17px !important;"
                    >{{ category.total }}</b-th>
                  </b-tr>
      
                  <b-tr v-for="item in category.items" :key="item.id">
                    <b-td class="py-2 px-2">{{ item.name }} </b-td>
                    <b-td class="py-2 px-2">
                      <b-form-input
                        :key="`iq_${item.id}`"
                        placeholder="Введите количество"
                        type="number"
                        min="0"
                        max="10000"
                        size="sm"
                        v-model="itemQuantities[item.id]"
                      ></b-form-input>    
                    </b-td>
                  </b-tr>
                </template>
              </b-tbody>
            </b-table-simple>
  
            <div class="fixed-bottom-buttons">
              <b-button 
                @click="disableChanges"
                :disabled="loading"
              >Отменить</b-button>
        
              <b-button 
                type="submit" 
                variant="primary"
                class="ml-2"
                :disabled="loading"
              >Сохранить</b-button>
            </div>
          </b-form>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { API_TRANSPORT_TYPES } from '@/constants';

export default {
  props: {
    items: { type: Array, required: true },
    services: { type: Array, required: false }
  },
  data() {
    return {
      loading: true,
      notGroupedCategories: [],
      categories: {},
      itemQuantities: {},
      availableTypes: new Set()
    };
  },
  computed: {
    totalPS() {
      let total = 0;

      for(let key in this.categories) {
        total += this.categories[key].total;
      }

      return total;
    },    
  },
  watch: {
    itemQuantities: {
      handler(value) {
        this.makeCategories();
      },
      deep: true,
    },    
  },
  mounted() {
    this.prepareAvaibleTypes();
    this.loadTransportTypes();
  },
  methods: {
    prepareAvaibleTypes() {
      this.services.forEach((service_id) => {
        if ([994, 995, 996, 997].includes(service_id)) {
          this.availableTypes.add('FCL и LCL');
        } else if ([992, 993].includes(service_id)) {
          this.availableTypes.add('FTL и LTL');
        }
      });
    },

    loadTransportTypes() {
      api.call('get', `${API_TRANSPORT_TYPES}`).then(({data}) => {
        this.notGroupedCategories = data;
        this.loadQuotationTransportTypes();
      })
    },

    loadQuotationTransportTypes() {
      this.items.forEach((item) => {
        this.itemQuantities[item.transport_item_id] = item.quantity;
      })

      this.makeCategories();
      this.loading = false;
    },

    makeCategories() {
      this.notGroupedCategories = this.notGroupedCategories.map(item => {
          let quantity = 0;

          if (this.itemQuantities[item.id]) {
            quantity = this.itemQuantities[item.id];
          }

          return { ...item, quantity: quantity };
        });        

        this.categories = this.groupTypes(this.notGroupedCategories);
    },

    groupTypes(items) {
      let grouped = {};

      items.forEach(element => {
        if (!grouped[element.category.name]) {
          grouped[element.category.name] = {
            items: [],
            total: 0,
            category: element.category,
            hide: !this.availableTypes.has(element.category.type)
          };
        }

        grouped[element.category.name]['items'].push(element);
        grouped[element.category.name]['total'] += Number(element.quantity);
      });

      return grouped;
    },

    disableChanges() {
      this.$emit("close");
    },

    saveChanges() {
      let items = [];

      this.notGroupedCategories.forEach((item) => {
        if (this.itemQuantities[item.id]) {
          items.push({
            transport_item_id: item.id,
            transport_category_id: item.category_id,
            transport_item_name: item.name,
            transport_category_name: item.category.name,
            transport_category_type: item.category.type,
            quantity: this.itemQuantities[item.id]
          });
        }
      })

      this.$emit("save", items);
    },
  },
};
</script>
<style scoped>
  .fixed-bottom-buttons {
    position: relative;
    width: 100%;
    bottom: 0;
    right: 0px;
    padding: 15px 7px 7px 25px;
    text-align: right;
    border-top: 1px solid #dbdbdb;
  }
</style>